export const OktaClientId = '0oaop0jixngcdBAzt696'
export const ENV = 'regulation' as string
export const OVERSIGHT_ENV_NAME = 'oversight-staging'
export const GCS_ENV_NAME = 'regulation'
export const SUBDOMAIN_SUFFIX = 'gcs-staging'
